import { useEffect, useRef, useState } from "react";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { AppDrawer } from "@/components/YhDrawer";
import { YhForm } from "@/components/YhFormBox";
import { Table, message } from "antd";
import { timestampToTime } from "@/utils/utils";
import { ColumnsType } from "antd/es/table";
import { useLockFn } from "ahooks";
import { useDetailModel } from "../detailModel";
import { noBillDataModel } from "./noBillDataModel";
import { InvoiceApply } from "@/views/invoice/manage/InvoiceManageTypes";
import { invoiceManageService } from "@/views/invoice/manage/InvoiceManageService";
import BillDetailRender from "@/views/invoice/manage/BillDetailRender";

export const ApplyInvoice = () => {

    const { user } = useDetailModel();
    const { selectedData, applyInvoiceVisible, setApplyInvoiceVisible, onSearch } = noBillDataModel();
    const [dataSource, setDataSource] = useState<InvoiceApply[]>([])
    const formRef = useRef<IYhFormRef>();

    const formConfig: IYhForm = {
        labelCol: { span: 6 },
        disabled: false,
        items: [
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "状态",
                fieldName: "status",
                span: 24,
                ds: [
                    {
                        label: '审核通过',
                        value: 1
                    },
                    {
                        label: '审核驳回',
                        value: 8
                    }
                ],
                rules: [{
                    required: true,
                    message: "状态为必选项！"
                }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "审核人",
                fieldName: "approver",
                span: 24,
                disable: true,
                placeholder: "自动生成"
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "审核时间",
                fieldName: "reviewTime",
                span: 24,
                disable: true,
                placeholder: "自动生成"
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                span: 24
            }
        ]
    };

    const columns: ColumnsType<InvoiceApply> = [
        {
            title: '序号',
            align: "center",
            width: 40,
            render: (v, r, i) => i + 1
        },
        {
            title: '客户名称',
            dataIndex: 'partnerName',
            align: "center",
            width: 100,
        },
        {
            title: '单据编号',
            dataIndex: 'tradeCode',
            align: "center",
            width: 80,
            ellipsis: true,
            render: (t, r) => BillDetailRender(t, r.branch ?? '', r.tradeCode ?? '', r.tradeTypeCode ?? '')
        },
        {
            title: '单据金额',
            dataIndex: 'billAmount',
            width: 50,
            ellipsis: true,
            align: "center",
            render: (text, record) => (Math.abs(text))
        }
    ];

    useEffect(() => {
        formRef.current?.setFieldsValue({ approver: user.userName })
        formRef.current?.setFieldsValue({ reviewTime: timestampToTime(new Date().getTime()) })
        setDataSource(selectedData);
    }, [applyInvoiceVisible])

    const onOk = useLockFn(async () => {
        try {
            let formData = await formRef.current?.validateFields();
            if (formData) {
                const reqData = {
                    ...formData,
                    invoiceApplyVos: selectedData
                };
                let insertRet = await invoiceManageService.invoiceApplyApproval(reqData);
                if (insertRet) {
                    message.success("保存成功!");
                    onSearch();
                    setApplyInvoiceVisible(false);
                } else {
                    message.error("保存失败!");
                }
            }
        } catch (e) {
            console.log("系统错误" + e);
        }
    })

    const onCancel = () => {
        setApplyInvoiceVisible(false);
    }

    return (
        <AppDrawer
            {...{
                title: "开票审核",
                visible: applyInvoiceVisible,
                closable: true,
                onOk,
                onCancel,
                showFooter: true,
                width: 600,
                okText: "保存",
                cancelText: "返回"
            }}
        >
            <YhForm formRef={formRef} {...formConfig} />
            <Table
                rowKey={record => record.key}
                columns={columns}
                dataSource={dataSource}
                pagination={{
                    showTotal: (total: number) => `共${total}条`,
                    position: ["bottomCenter"],
                }}
                scroll={{ x: 'max-content', y: "calc(100vh - 446px)" }}
            />
        </AppDrawer>
    )
}
